import Swiper, { Navigation, HashNavigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';


var swiper = Swiper;
var init = false;

function accessSwiper() {
  if (window.innerWidth <= 799) {
    if (!init) {
      init = true;
      swiper = new Swiper(".access-carousel__container--bottom", {
        modules: [Navigation, HashNavigation],
        slidesPerView: 1.025,
        spaceBetween: 15,
        centeredSlides: true,
        a11y: true,
        loop: true,
        hashNavigation: {
          watchState: true
        },
        navigation: {
          nextEl: '.swiper-button-next__access',
          prevEl: '.swiper-button-prev__access',
        },
        breakpoints: {
          401: {
            spaceBetween: 30,
          },
        },
      });
    }
  } else if (init) {
    swiper.destroy();
    init = false;
  }
}
accessSwiper();
window.addEventListener("resize", accessSwiper);

function platformSwiper() {
  init = false;
  if (window.innerWidth <= 799) {
    if (!init) {
      init = true;
      swiper = new Swiper(".access-carousel__container--mobile", {
        modules: [Navigation, HashNavigation],
        slidesPerView: 1.025,
        spaceBetween: 15,
        centeredSlides: true,
        a11y: true,
        loop: true,
        hashNavigation: {
          watchState: true
        },
        navigation: {
          nextEl: '.swiper-button-next__platforms',
          prevEl: '.swiper-button-prev__platforms',
        },
        breakpoints: {
          401: {
            spaceBetween: 30,
          },
        },
      });
    }
  } else if (init) {
    swiper.destroy();
    init = false;
  }
}
platformSwiper();
window.addEventListener("resize", platformSwiper);